module.exports = __webpack_public_path__ + "media/images/logo-weo-15-ans-alt-3f45d5312010b6e2e1fe15646e706404.png";